import React, { createContext, useContext, useState } from "react";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [leads, setLeads] = useState([]);
  const [leadsData, setLeadsData] = useState([]);
  const [promptsDataCompany, setPromptsDataCompany] = useState(null);
  const [promptsDataPeople, setPromptsDataPeople] = useState({
    source: null, // "api" | "db"
    data: [],
  });
  const [showPromtData, setShowPromtData] = useState(false);
  const [showUrlData, setShowUrlData] = useState(false);
  const [viewMode, setViewMode] = useState("companies");
  const [prompt, setPrompt] = useState("");
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  const [promptInput, setPromptInput] = useState("General Managers of Hotels and Resorts");
  const [defaultLocation, setDefaultLocation] = useState("");
  const [contactsCountMap, setContactsCountMap] = useState({});

  const normalizePrompt = (p) => p.trim().toLowerCase();

  const getRandomContacts = () => {
    const rand = Math.random();

    if (rand < 0.75) {
      return Math.floor(180000 + Math.random() * 50000);
    } else {
      return Math.floor(140000 + Math.random() * 30000);
    }
  };

  const getContactsCount = (prompt) => {
    if (!prompt) return 0;

    const key = `contacts_${prompt.trim().toLowerCase()}`;

    const stored = sessionStorage.getItem(key);
    if (stored) return Number(stored);

    const rand = Math.random();
    let value;

    if (rand < 0.75) {
      value = Math.floor(180000 + Math.random() * 50000);
    } else {
      value = Math.floor(140000 + Math.random() * 30000);
    }

    sessionStorage.setItem(key, value);
    return value;
  };

  return (
    <AppContext.Provider
      value={{
        leads,
        setLeads,
        leadsData,
        setLeadsData,
        promptsDataCompany,
        setPromptsDataCompany,
        showPromtData,
        setShowPromtData,
        showUrlData,
        setShowUrlData,
        viewMode,
        setViewMode,
        prompt,
        setPrompt,
        promptsDataPeople,
        setPromptsDataPeople,
        isSearchLoading,
        setIsSearchLoading,
        loadingMessage,
        setLoadingMessage,
        promptInput,
        setPromptInput,
        defaultLocation,
        setDefaultLocation,
        getContactsCount,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

// Custom hook for easy usage
export const useAppContext = () => useContext(AppContext);
